import React, {Component} from 'react';

import {icons} from "../../assets/icons";

import {container, content, footer, logo, text} from "./styles";

class Footer extends Component {
  render() {
    return (
      <footer style={{...footer}}>
        <div style={{...container}}>
          <div style={{...content}}>
            <span style={{...text}}>Powered by</span>
            <img style={{...logo}} src={icons.logo_digitum_light} alt='Digitum logo'/>
            <span style={{...text}}>&copy; Digitum {new Date().getFullYear()}</span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;